import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-google-logman',
    templateUrl: './google-logman.component.html',
    styleUrls: ['./google-logman.component.css'],
    standalone: false
})
export class GoogleLogmanComponent implements OnInit {

  ariLinks = [
    {
      service: 'Property Data (Transaction)',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createGoogleAriTransaction',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/createGoogleAriTransaction/{shortTermRentalId}',
      apiUrl: 'GET /api/2.6/google/ari/transaction/{shortTermRentalId} • POST /api/2.6/google/ari/transaction/{shortTermRentalId}/push'
    },
    {
      service: 'Unit Availability',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createGoogleUnitAvailabilityUpdate',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/createGoogleUnitAvailabilityUpdate/{shortTermRentalId}',
      apiUrl: 'GET /api/2.6/google/ari/avail/unit-availability/{shortTermRentalId}?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD • POST /api/2.6/google/ari/avail/unit-availability/{shortTermRentalId}/push?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD'
    },
    {
      service: 'Inventory Count',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createGoogleAriInvCount',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/createGoogleAriInvCount/{shortTermRentalId}',
      apiUrl: 'GET /api/2.6/google/ari/inv/count/{shortTermRentalId}?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD • POST /api/2.6/google/ari/inv/count/{shortTermRentalId}/push?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD'
    },
    {
      service: 'LOS Rates',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createGoogleAriLosRate',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/createGoogleAriLosRate/{shortTermRentalId}',
      apiUrl: 'GET /api/2.6/google/ari/rates/los/{shortTermRentalId}?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD • POST /api/2.6/google/ari/rates/los/{shortTermRentalId}/push?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD'
    },
    {
      service: 'Tax & Fee',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createGoogleAriTaxFee',
      propertyLogmanUrl: 'https://admin.kbmhawaii.com/logmans/short-term-rental/createGoogleAriTaxFee/{shortTermRentalId}',
      apiUrl: 'GET /api/2.6/google/ari/tax/taxfee/{shortTermRentalId} • POST /api/2.6/google/ari/tax/taxfee/{shortTermRentalId}/push'
    }
  ];

  vrFeedLinks = [
    {
      service: 'Listing (single)',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createGoogleVrFeed',
      propertyLogmanUrl: null,
      apiUrl: 'GET /api/2.6/google/vr/listing/{shortTermRentalId}'
    },
    {
      service: 'Listings ZIP (all)',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createGoogleVrFeed',
      propertyLogmanUrl: null,
      apiUrl: 'GET /api/2.6/google/vr/listings/all?lang=en'
    },
    {
      service: 'Listings XML (all, merged)',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/createGoogleVrFeed',
      propertyLogmanUrl: null,
      apiUrl: 'GET /api/2.6/google/vr/listings/all/xml?lang=en'
    },
    {
      service: 'Read XML from S3',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/google-vr-feed/upload',
      propertyLogmanUrl: null,
      apiUrl: 'GET /api/2.6/google/vr/xml/s3?key=google-vr-feed/google_vr_feed_download_local.xml'
    },
    {
      service: 'Read ZIP from S3',
      logmanUrl: 'https://admin.kbmhawaii.com/logmans/google-vr-feed/upload',
      propertyLogmanUrl: null,
      apiUrl: 'GET /api/2.6/google/vr/zip/s3?key=google-vr-feed/google_vr_feed_download_local.xml.zip'
    }
  ];

  constructor(private messageService: MessageService) { }

  ngOnInit(): void {
  }

  openLink(url: string): void {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

}

